import { render, staticRenderFns } from "./FValidatorsInfo.vue?vue&type=template&id=869c7944&"
import script from "./FValidatorsInfo.vue?vue&type=script&lang=js&"
export * from "./FValidatorsInfo.vue?vue&type=script&lang=js&"
import style0 from "./FValidatorsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports